module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$route.fullPath != '/home' ? 'footer' : 'footer-bg'
  }, [_c('div', {
    staticClass: "container w"
  }, [_c('div', {
    staticClass: "footer-menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('ul', [_c('li', {
    staticClass: "items-group"
  }, [_c('h3', [_vm._v("软件中心")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('23')
      }
    }
  }, [_vm._v("在线软件")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('24')
      }
    }
  }, [_vm._v("软件下载")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('21')
      }
    }
  }, [_vm._v("合作介绍")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('25')
      }
    }
  }, [_vm._v("医患沟通应用介绍")])])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "items-group"
  }, [_c('h3', [_vm._v("产品中心")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('12')
      }
    }
  }, [_vm._v("设计说明")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('13')
      }
    }
  }, [_vm._v("售后服务")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('15')
      }
    }
  }, [_vm._v("下单操作流程")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('16')
      }
    }
  }, [_vm._v("接单操作流程")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('17')
      }
    }
  }, [_vm._v("种植模块说明")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('18')
      }
    }
  }, [_vm._v("固定模块说明")])])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "items-group"
  }, [_c('h3', [_vm._v("齿科学院")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('31')
      }
    }
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('32')
      }
    }
  }, [_vm._v("企业招聘")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('33')
      }
    }
  }, [_vm._v("荣誉奖项")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('34')
      }
    }
  }, [_vm._v("线上培训")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('35')
      }
    }
  }, [_vm._v("线下培训")])])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "items-group"
  }, [_c('h3', [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('41')
      }
    }
  }, [_vm._v("有关医小智")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('43')
      }
    }
  }, [_vm._v("投诉与反馈")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('44')
      }
    }
  }, [_vm._v("在线客服")])])])])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left"
  }, [_c('h3', [_vm._v("尊敬的用户，您好!")]), _vm._v(" "), _c('p', [_vm._v("医小智为您带来全新的齿科在线设计服务，不管您什么时间需要，多远的距离需要，都可以在医小智享受专业高效的义齿设计服务。1分钟完成下单，5分钟反馈数字化扫描数据品质，实时更新临床信息，30分钟完成数字化线上设计，输出制造文件和治疗方案，24小时内免费修改设计方案。我们的目标是帮助您及您的客户打造一口健康、美丽的牙齿，让您自信地展开笑容!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_c('ul', {
    staticClass: "copyright clearfix"
  }, [_c('li', [_vm._v("Copyright © 2022 医小智（日照）工业互联网有限公司 版权所有")])]), _vm._v(" "), _c('ul', {
    staticClass: "icp"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=37110202371204",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("鲁公网安备37110202371204")])]), _vm._v(" "), _c('li', {
    staticClass: "public-security"
  }, [_c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033469"
    }
  }, [_vm._v("\n              鲁B2-20240306\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("鲁ICP备2022031907号-1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c512bb7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/MFooter.vue
// module id = 652
// module chunks = 0